import { z } from 'zod';

export const CheckHomeBuyerPasscodeRequestSchema = z.object({
  brokerageId: z.string().uuid('BrokerageId must be a valid GUID'),
  clientId: z.number().int('ClientId must be an integer').positive('ClientId must be positive'),
});

export const CheckHomeBuyerPasscodeResponseSchema = z.object({
  exists: z.boolean(),
  message: z.string().nullable().optional(),
  status: z.string(),
});

export const SetupHomeBuyerPasscodeRequestSchema = z.object({
  brokerageId: z.string().uuid('BrokerageId must be a valid GUID'),
  clientId: z.number().int('ClientId must be an integer').positive('ClientId must be positive'),
  passcode: z
    .string()
    .length(4, 'Passcode must be exactly 4 digits')
    .regex(/^\d{4}$/, 'Passcode must contain only digits'),
});

export const SetupHomeBuyerPasscodeResponseSchema = z.object({
  status: z.string(),
  message: z.string().nullable().optional(),
});

export const ValidateHomeBuyerPasscodeRequestSchema = z.object({
  brokerageId: z.string().uuid('BrokerageId must be a valid GUID'),
  clientId: z.number().int('ClientId must be an integer').positive('ClientId must be positive'),
  passcode: z
    .string()
    .length(4, 'Passcode must be exactly 4 digits')
    .regex(/^\d{4}$/, 'Passcode must contain only digits'),
});

export const ValidateHomeBuyerPasscodeResponseSchema = z.object({
  status: z.string(),
  message: z.string().nullable().optional(),
});

export type CheckHomeBuyerPasscodeRequest = z.infer<typeof CheckHomeBuyerPasscodeRequestSchema>;
export type CheckHomeBuyerPasscodeResponse = z.infer<typeof CheckHomeBuyerPasscodeResponseSchema>;
export type SetupHomeBuyerPasscodeRequest = z.infer<typeof SetupHomeBuyerPasscodeRequestSchema>;
export type SetupHomeBuyerPasscodeResponse = z.infer<typeof SetupHomeBuyerPasscodeResponseSchema>;
export type ValidateHomeBuyerPasscodeRequest = z.infer<
  typeof ValidateHomeBuyerPasscodeRequestSchema
>;
export type ValidateHomeBuyerPasscodeResponse = z.infer<
  typeof ValidateHomeBuyerPasscodeResponseSchema
>;
